import '/home/runner/work/dialog/dialog/docs/demo/bootstrap.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"bootstrap","toc":"menu","filename":"docs/demo/bootstrap.md","lastUpdated":1785141763000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-bootstrap-demo-bootstrap"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/bootstrap.md?type=demo')
};